/**
 * Role defines all supported & known roles of the customer data frontend.
 * For details see com.bmw.ispi.customer.data.frontend.authentication.wen.oidc.Roles
 */
export enum Role {
  CDF_USER = 'cdf_user',
  CDF_USER_READ = 'cdf_user_read',
  CDF_USER_SALES = 'cdf_user_sales',
  CDF_ADMIN_GLOBAL = 'cdf_admin_global',
  CDF_ADMIN_LOCAL_WRITE = 'cdf_admin_local_write',
  CDF_ADMIN_LOCAL_READ = 'cdf_admin_local_read',
  CDF_REPORTING = 'cdf_reporting',
}

export const RoleGroup = Object.freeze({
  CDF: Object.freeze([
    Role.CDF_USER,
    Role.CDF_USER_READ,
    Role.CDF_USER_SALES,
    Role.CDF_ADMIN_GLOBAL,
    Role.CDF_ADMIN_LOCAL_WRITE,
    Role.CDF_ADMIN_LOCAL_READ,
  ]),
  CDF_WRITE: Object.freeze([
    Role.CDF_USER,
    Role.CDF_USER_SALES,
    Role.CDF_ADMIN_GLOBAL,
    Role.CDF_ADMIN_LOCAL_WRITE,
    Role.CDF_ADMIN_LOCAL_READ,
  ]),
  CDF_ADMIN: Object.freeze([Role.CDF_ADMIN_GLOBAL, Role.CDF_ADMIN_LOCAL_WRITE, Role.CDF_ADMIN_LOCAL_READ]),
  CDF_ADMIN_WRITE: Object.freeze([Role.CDF_ADMIN_GLOBAL, Role.CDF_ADMIN_LOCAL_WRITE]),
  CDF_ADMIN_GLOBAL: Object.freeze([Role.CDF_ADMIN_GLOBAL]),
});
